<template>
    <!--
      <alert-list
      ref="alertListEl"
      :journey-id="journeyId" />
    -->
    <div />
</template>

<script lang="ts" setup>
// import AlertList from '../../monitoring/-components/alert-list.vue'

const props = defineProps({
  journeyId: String as PropType<string | null>
})
const { journeyId } = toRefs(props)
watch(
  () => journeyId?.value,
  (val: any) => {
    refresh()
  }
)
const alertListEl = ref<any>(null)
const refresh = () => {
  alertListEl.value && alertListEl.value.refresh()
}
defineExpose({ refresh })
</script>
